const SvgVfuga60 = () => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 60 60">
    <path fill="#373737" d="m39 26-9.022 22.17L21 26H2v32h56V26z" />
    <path fill="#373737" d="M28.718 33.248h2.542L36.574 16h-2.726l-3.802 13.079L26.266 16H23.38z" />
  </svg>;
export default SvgVfuga60;